import { ref, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b8ef2ac6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "list"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "用户名：", -1));
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "list"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "应用权限：", -1));
const _hoisted_6 = {
  class: "content"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'DetailModal',
  props: {
    modelVisible: {
      default: false,
      type: Boolean
    },
    editItem: {
      default: () => {},
      type: Object
    }
  },
  emits: ['update:modelVisible'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = ref(false);
    const closeModal = () => {
      emit('update:modelVisible', false);
    };
    watch(() => props.modelVisible, val => {
      visible.value = val;
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        title: "权限详情",
        onCancel: closeModal,
        open: visible.value,
        "onUpdate:open": _cache[0] || (_cache[0] = $event => visible.value = $event),
        footer: false,
        centered: ""
      }, {
        default: _withCtx(() => {
          var _props$editItem, _props$editItem2;
          return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, _toDisplayString((_props$editItem = __props.editItem) === null || _props$editItem === void 0 ? void 0 : _props$editItem.name), 1)]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, _toDisplayString((_props$editItem2 = __props.editItem) === null || _props$editItem2 === void 0 ? void 0 : _props$editItem2.appNameList), 1)])];
        }),
        _: 1
      }, 8, ["open"]);
    };
  }
});